import React from 'react';
import SectionH2 from '../heading/SectionH2';
import FiveStars from '../../img/five_stars.svg';
import useBuzzInTotal from '../../hooks/useBuzzInTotal';
import BuzzCountNumber from './BuzzCountNumber';

const BusinessTestimonials = ({ theme = 'light' }) => {
  const count = useBuzzInTotal();

  return (
    <div class="">
      <div class="flex flex-col items-center px-10 pb-5 pt-1">
        <SectionH2 title={'Residents Love Lowkey'} theme={theme} />
        <div className="text-md mb-8 text-center font-space-grotesk-regular font-normal text-black md:mb-12 xl:mb-16">
          Lowkey has buzzed in
          <span className="mx-1.5 inline-block rounded-lg bg-gray-900 px-2.5 py-0.5 font-mono font-bold italic tabular-nums text-green-lowkey">
            <BuzzCountNumber count={count} />
          </span>
          guests, an amenity your residents will actually use
        </div>
      </div>

      <div class="flex flex-row justify-start overflow-x-auto px-4 sm:pt-5 lg:justify-center">
        <div class="flex min-w-fit flex-row space-x-4 text-black">
          <div class="flex w-72 flex-col rounded-xl bg-blue-400">
            <div class="flex flex-col items-start space-y-3 p-5">
              <div class="flex flex-row items-center space-x-3 font-space-grotesk-medium text-sm">
                <div class="flex flex-col space-y-0">
                  <p class="font-space-grotesk-semi-bold">Nina D</p>
                  <p class="font-space-grotesk-regular">Seattle, WA</p>
                </div>
              </div>

              <div>
                <img loading="lazy" src={FiveStars} class="my-2 h-5 object-contain" alt={'five stars'} />
                <p class="font-space-grotesk-semi-bold">"Great app, has made my life easier"</p>
              </div>
              <p>
                This app is awesome if you live in an apartment complex with a buzzer. Super convenient for food
                delivery and having large groups of friends over. I also like the feature of being able to put a
                passcode for different activities- makes me feel much more secure.
              </p>
            </div>
          </div>
          <div class="flex w-72 flex-col rounded-xl bg-blue-400">
            <div class="flex flex-col items-start space-y-3 p-5">
              <div class="flex flex-row items-center space-x-3 font-space-grotesk-medium text-sm">
                <div class="flex flex-col space-y-0">
                  <p class="font-space-grotesk-semi-bold">Andre W</p>
                  <p class="font-space-grotesk-regular">Atlanta, GA</p>
                </div>
              </div>
              <div>
                <img loading="lazy" src={FiveStars} class="my-2 h-5 object-contain" alt={'five stars'} />
                <p class="font-space-grotesk-semi-bold">"I love this app it’s genius!"</p>
              </div>
              <p>
                I'm able to easily share access to my apartment buzzer with my roomate through the app which is great in
                case he's not around. We also use it to schedule access for when cleaners come over once a month while
                we're working.
              </p>
            </div>
          </div>
          <div class="flex w-72 flex-col rounded-xl bg-blue-400">
            <div class="flex flex-col items-start space-y-3 p-5">
              <div class="flex flex-row items-center space-x-3 font-space-grotesk-medium text-sm">
                <div class="flex flex-col space-y-0">
                  <p class="font-space-grotesk-semi-bold">Ethan D</p>
                  <p class="font-space-grotesk-regular">Los Angeles, CA</p>
                </div>
              </div>

              <div>
                <img loading="lazy" src={FiveStars} class="my-2 h-5 object-contain" alt={'five stars'} />
                <p class="font-space-grotesk-semi-bold">"Super convenient, especially for food delivery"</p>
              </div>
              <p>
                Love this app for whenever I order UberEats or DoorDash. My apartment is super annoying to go down to
                the front door and I can't answer calls while I'm working so this has made ordering food way way easier.
              </p>
            </div>
          </div>
          <div class="flex w-72 flex-col rounded-xl bg-blue-400">
            <div class="flex flex-col items-start space-y-3 p-5">
              <div class="flex flex-row items-center space-x-3 text-sm">
                <div class="flex flex-col space-y-0">
                  <p class="font-space-grotesk-semi-bold">Morganne K</p>
                  <p class="font-space-grotesk-regular">Tampa, FL</p>
                </div>
              </div>

              <div>
                <img loading="lazy" src={FiveStars} class="my-2 h-5 object-contain" alt={'five stars'} />
                <p class="font-space-grotesk-semi-bold">"Security features make me feel safer"</p>
              </div>
              <p>
                Being able to check the activity history of who came in on the app is really nice and gives me peace of
                mind living alone in an apartment.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-row justify-center pt-10 sm:pt-20">
        <a
          href="#pricing"
          class="inline-flex items-center justify-center rounded-lg border border-green-lowkey bg-green-lowkey py-3 px-5 text-center text-base font-medium text-black hover:bg-black hover:text-green-lowkey focus:ring-4 focus:ring-gray-800"
        >
          View pricing
          <svg
            class="ml-2 -mr-1 h-5 w-5 rotate-90"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
              clip-rule="evenodd"
            ></path>
          </svg>
        </a>
      </div>
    </div>
  );
};

export default BusinessTestimonials;
